import { render, staticRenderFns } from "./ReviewCommentsTooltip.vue?vue&type=template&id=5786ceb4"
import script from "./ReviewCommentsTooltip.vue?vue&type=script&lang=js"
export * from "./ReviewCommentsTooltip.vue?vue&type=script&lang=js"
import style0 from "./ReviewCommentsTooltip.vue?vue&type=style&index=0&id=5786ceb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports